import { render, staticRenderFns } from "./TitleCard.vue?vue&type=template&id=06a55cd5&scoped=true&"
import script from "./TitleCard.vue?vue&type=script&lang=%20ts&"
export * from "./TitleCard.vue?vue&type=script&lang=%20ts&"
import style0 from "./TitleCard.vue?vue&type=style&index=0&id=06a55cd5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a55cd5",
  null
  
)

export default component.exports